import SmartNavigator from '../generic/SmartNavigator'
import GenericKPIs from '../dashboard/GenericKPIs'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import useSmartTranslation from '../generic/hooks/useSmartTranslation/useSmartTranslation'
import DeviceAvailabilityChart from '../dashboard/DeviceAvailabilityChart'

const MainDashboardPlanning = ({ activePath }) => {
  const [config] = useFrontEndConfig()
  const { t_ } = useSmartTranslation()

  if (config === null) return null

  const componentsInfo = [
    {
      title: t_('Capacity vs Load'),
      component: config.dashboardPlanningCapacityLoad ? <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardPlanningCapacityLoad} /> : <DeviceAvailabilityChart />,
      permissionCode: 'CAPACITY VS LOAD'
    },
    {
      title: t_('Delayed FOs'),
      component: <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardPlanningDelayedFo} />,
      permissionCode: 'DASHBOARD_PLANNING_DELAYED_FO'
    },
    {
      title: t_('FOs Status'),
      component: <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardPlanningFoStatus} />,
      permissionCode: 'DASHBOARD_PLANNING_FO_STATUS'
    },
    {
      title: t_('Planned Load'),
      component: <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardPlanningPlannedLoad} />,
      permissionCode: 'DASHBOARD_PLANNING_PLANNING_PLANNED_LOAD'
    }
  ]

  return <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
}

export default MainDashboardPlanning
